// @flow
import $ from 'jquery';
import JQueryView, { on } from '../../../../common/JQueryView';

export default class FormView extends JQueryView {
  static limitByte = 62914560;
  static errorMessageFormat = 'PDF形式のファイルを選択してください';
  static errorMessageSize = '60MB以下のファイルを選択してください';
  static errorMessageSingleFile = '1ファイルのみ選択してください';

  constructor() {
    super('.drop-zone-wrapper');
  }

  @on({ event: 'dragenter dragover', selector: '#drop_zone' })
  onEnterDropZone(event: any) {
    event.preventDefault();
  }

  @on({ event: 'dragleave', selector: '#drop_zone' })
  onLeaveDropZone(event: any) {
    event.preventDefault();
  }

  @on({ event: 'drop', selector: '#drop_zone' })
  onDropDropZone(event: any) {
    event.preventDefault();
    const files = event.originalEvent.dataTransfer.files;
    const validateResult = this.validate(files);

    if (validateResult.status) {
      $(
        'input[name="company_stock_option_right_type_form[right_type_attributes][agreement]"]:file',
      )[0].files = files;
      $(
        '#company_stock_option_right_type_form_right_type_attributes__destroy',
      ).val(false);
      this.render();
    } else {
      validateResult.errorMessages.forEach(msg => {
        $('.drop-zone').after(`<small class="invalid-feedback">${msg}</small>`);
      });
    }
  }

  @on({
    event: 'change',
    selector:
      'input[name="company_stock_option_right_type_form[right_type_attributes][agreement]"]:file',
  })
  changeInputFile() {
    this.render();
  }

  @on({
    event: 'click',
    selector: '#delete-file-btn',
  })
  removeFile() {
    $(
      '#company_stock_option_right_type_form_right_type_attributes_agreement',
    ).val('');
    $(
      '#company_stock_option_right_type_form_right_type_attributes__destroy',
    ).val('1');
    $('#js-file-container').addClass('invisible');
  }

  render() {
    const files = $(
      '#company_stock_option_right_type_form_right_type_attributes_agreement',
    ).prop('files');

    $('.invalid-feedback').remove();

    const validateResult = this.validate(files);

    if (validateResult.status) {
      const file = files[0];
      $('#filename').text(file.name);
      $('#js-file-container').removeClass('invisible');
    } else {
      validateResult.errorMessages.forEach(msg => {
        $('.drop-zone').after(`<small class="invalid-feedback">${msg}</small>`);
      });
    }
  }

  validate(files: FileList) {
    const errorMessages = [];

    if (files.length > 1) {
      errorMessages.push(FormView.errorMessageSingleFile);
    } else {
      const file = files[0];

      if (file.type !== 'application/pdf') {
        errorMessages.push(FormView.errorMessageFormat);
      }

      if (file.size > FormView.limitByte) {
        errorMessages.push(FormView.errorMessageSize);
      }
    }

    return { status: !errorMessages.length, errorMessages };
  }
}
